var _excluded = ["inNewTab"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import React, { memo, useEffect, useRef } from "react";
import { Box, GridBox, Font, PageContainer, OuterlinkActionIcon, useSsr, Link } from "@pochta/ui";
import styled, { keyframes } from "styled-components";
import BannerPlace from "../../../../promotion/BannerPlace";
import isActiveUrl from "../../../../../helpers/isActiveUrl";
import HeaderLink from "./HeaderLink";
import isExternalHost from "../helpers/isExternalHost";
import focusOnRef from "../helpers/focusOnRef";
var slideUp = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);
var SubmenuContainer = styled(Box).withConfig({
  displayName: "Submenu__SubmenuContainer",
  componentId: "sc-kjyoaf-0"
})(["display:none;", "{display:block;}position:absolute;z-index:", ";width:100%;top:100%;left:0;padding:18px 0;animation:", " 0.5s ease-in-out;box-shadow:0 10px 8px rgba(0,0,0,0.05);"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.desktop;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.zIndex.higher;
}, slideUp);
export var SubmenuLinkInner = styled(HeaderLink).withConfig({
  displayName: "Submenu__SubmenuLinkInner",
  componentId: "sc-kjyoaf-1"
})(["position:relative;display:flex;color:", ";&:visited{color:", ";}&:hover{color:", ";}&:before{content:\"\";width:8px;height:8px;background:", ";border-radius:5px;position:absolute;top:50%;margin-top:-4px;left:-19px;}span{white-space:nowrap;}"], function (_ref3) {
  var color = _ref3.theme.color,
      isActive = _ref3.isActive;
  return !isActive ? color.text.black.base : color.importance.primary.base;
}, function (_ref4) {
  var color = _ref4.theme.color,
      isActive = _ref4.isActive;
  return !isActive ? color.text.black.base : color.importance.primary.base;
}, function (_ref5) {
  var color = _ref5.theme.color,
      isActive = _ref5.isActive;
  return !isActive ? color.text.link.hover : color.importance.primary.base;
}, function (_ref6) {
  var theme = _ref6.theme,
      isActive = _ref6.isActive;
  return isActive ? theme.color.importance.primary.base : "transparent";
});
export var SubmenuLink = function SubmenuLink(_ref7) {
  var _ref7$inNewTab = _ref7.inNewTab,
      inNewTab = _ref7$inNewTab === void 0 ? false : _ref7$inNewTab,
      props = _objectWithoutProperties(_ref7, _excluded);

  var inNewTabProps = {};

  if (inNewTab) {
    inNewTabProps = {
      target: "_blank",
      rel: "noreferrer"
    };
  }

  return /*#__PURE__*/React.createElement(SubmenuLinkInner, _extends({}, props, inNewTabProps));
};
var MIN_ITEMS_IN_COLUMN = 7;

var Submenu = function Submenu(_ref8) {
  var menu = _ref8.menu,
      parentActive = _ref8.parentActive,
      active = _ref8.active,
      _ref8$isFluid = _ref8.isFluid,
      isFluid = _ref8$isFluid === void 0 ? false : _ref8$isFluid,
      pageContainerMaxWidth = _ref8.pageContainerMaxWidth,
      menuItems = _ref8.menuItems,
      anchorRef = _ref8.anchorRef;

  var _useSsr = useSsr(),
      isSsr = _useSsr.isSsr;

  var nextMenuItem = menuItems[active + 1];
  var prevMenuItem = menuItems[active - 1];

  var _ref9 = menu || {},
      _ref9$items = _ref9.items,
      items = _ref9$items === void 0 ? [] : _ref9$items;

  var hasSubmenu = items.length > 0;
  var realItemsInColumnCount = Math.ceil(items.length / 2);
  var isTwoColumns = items.length > MIN_ITEMS_IN_COLUMN;
  var columns = [[], []];
  var linksContainer = useRef(null);

  if (isTwoColumns) {
    columns[0] = items.slice(0, realItemsInColumnCount);
    columns[1] = items.slice(realItemsInColumnCount, items.length);
  } else {
    columns[0] = items;
  }

  useEffect(function () {
    focusOnRef(linksContainer.current);
  }, [items]);
  var linkCheckCache = useRef({}).current;

  var checkLinkIsActive = function checkLinkIsActive(link) {
    if (isSsr) return false;

    if (!(link in linkCheckCache)) {
      linkCheckCache[link] = isActiveUrl(link);
    }

    return linkCheckCache[link];
  };

  if (!hasSubmenu) {
    return null;
  }

  return /*#__PURE__*/React.createElement(SubmenuContainer, {
    bg: "neutralsWhite.hex5",
    "data-submenu": "submenu"
  }, /*#__PURE__*/React.createElement(PageContainer, {
    fluid: isFluid,
    limitMaxWidthBreakpoint: pageContainerMaxWidth
  }, /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    justifyContent: "flex-start"
  }, active === 0 && anchorRef ? /*#__PURE__*/React.createElement(Link, {
    href: "#",
    onFocus: function onFocus() {
      return focusOnRef(anchorRef);
    },
    style: {
      opacity: 0
    },
    "aria-label": "\u041B\u043E\u0433\u0438\u043D"
  }) : /*#__PURE__*/React.createElement(Link, {
    href: "#",
    onFocus: function onFocus() {
      return focusOnRef(prevMenuItem);
    },
    style: {
      opacity: 0
    },
    "aria-label": "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u043F\u0443\u043D\u043A\u0442 \u043C\u0435\u043D\u044E"
  }), /*#__PURE__*/React.createElement(Box, {
    minWidth: 600
  }, /*#__PURE__*/React.createElement(GridBox, {
    row: true,
    p: "3px 0",
    flexBasis: "100%",
    maxWidth: "100%"
  }, /*#__PURE__*/React.createElement(GridBox, {
    xs: isTwoColumns ? 6 : 12,
    tabIndex: 0,
    ref: linksContainer,
    style: {
      outline: "none"
    }
  }, columns[0].map(function (_ref10) {
    var link = _ref10.link,
        title = _ref10.title;
    var inNewTab = isExternalHost(link);
    return /*#__PURE__*/React.createElement(Box, {
      p: "3px 0",
      key: title
    }, /*#__PURE__*/React.createElement(SubmenuLink, {
      isActive: checkLinkIsActive(link),
      underline: "none",
      size: "s",
      href: link,
      key: title,
      inNewTab: inNewTab
    }, /*#__PURE__*/React.createElement(Font, {
      size: "s"
    }, title), inNewTab && /*#__PURE__*/React.createElement(Box, {
      flexbox: true,
      alignItems: "center",
      pl: 3
    }, /*#__PURE__*/React.createElement(OuterlinkActionIcon, {
      fontSize: 16,
      color: "neutralsBlack.rgba15"
    }))));
  })), isTwoColumns && /*#__PURE__*/React.createElement(GridBox, {
    xs: 6
  }, columns[1].map(function (_ref11) {
    var link = _ref11.link,
        title = _ref11.title;
    var inNewTab = isExternalHost(link);
    return /*#__PURE__*/React.createElement(Box, {
      p: "3px 0",
      key: title
    }, /*#__PURE__*/React.createElement(SubmenuLink, {
      isActive: checkLinkIsActive(link),
      underline: "none",
      size: "s",
      href: link,
      key: title,
      inNewTab: inNewTab
    }, /*#__PURE__*/React.createElement(Font, {
      size: "s"
    }, title), inNewTab && /*#__PURE__*/React.createElement(Box, {
      flexbox: true,
      alignItems: "center",
      pl: 3
    }, /*#__PURE__*/React.createElement(OuterlinkActionIcon, {
      fontSize: 16,
      color: "neutralsBlack.rgba15"
    }))));
  })))), /*#__PURE__*/React.createElement(Link, {
    href: "#",
    onFocus: function onFocus() {
      return focusOnRef(nextMenuItem);
    },
    style: {
      opacity: 0
    },
    "aria-label": "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u043F\u0443\u043D\u043A\u0442 \u043C\u0435\u043D\u044E"
  }), Number.isInteger(parentActive) && Number.isInteger(active) && /*#__PURE__*/React.createElement(BannerPlace, {
    maxWidth: 360,
    maxHeight: 160,
    id: "menu-desktop-".concat(parentActive, "-").concat(active)
  }))));
};

export default /*#__PURE__*/memo(Submenu);